import { IconButton } from '@mui/material';
import { SnackbarKey, useSnackbar } from 'notistack';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';

interface SnackbarCloseButtonProps {
    /** The snackbar to close. notistack hands this to an `action` render function. */
    readonly snackbarKey: SnackbarKey;
}

/**
 * The dismiss on a toast — `SnackbarProvider`'s default, and the one any custom action re-renders.
 *
 * Here rather than inline in each because `CustomAlert` has a single action slot: a toast that
 * passes an `action` at all replaces the provider's close, so every toast with its own action has
 * to render one back or become the one toast in the app a member cannot dismiss early. One copy
 * also means one `aria-label`, rather than a screen-reader user meeting two names for one control.
 */
export default function SnackbarCloseButton({ snackbarKey }: Readonly<SnackbarCloseButtonProps>) {
    const { closeSnackbar } = useSnackbar();

    return (
        <IconButton aria-label="close" color="inherit" size="small" onClick={() => closeSnackbar(snackbarKey)}>
            <CloseXIcon fontSize="inherit" color="inherit" />
        </IconButton>
    );
}
